import React from 'react'
import { CLASS_PREFIX } from 'src/constants'
import './progress_indicator.scss'

const cls = `${CLASS_PREFIX}progress-indicator`

type Props = {
  steps: number;
  current: number;
}

export const ProgressIndicator: React.FC<Props> = ({ steps, current }) => {
  return <div className={cls}>
    {Array.from({ length: steps }, (_, i) => (
      <div key={i} className={`${cls}__step ${i <= current ? `${cls}__step--active` : ''}`} />
    ))}
  </div>
}
